import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { gunSliderData } from '../../constants/HomePageData';
import Button from '../Button/Button';
import SectionTitle from '../SectionTitle/SectionTitle';
import SingleRifle from '../SingleRifle/SingleRifle';
import styles from './RifleSlider.module.css';

// slider configuration
const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: false,
    nextArrow: false,
    responsive: [
        {
            breakpoint: 2025,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1
            }
        },
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
    ]
};

const RifleSlider = () => {
    return (
        <div className="rifleSlider">
            {/* Rifle slider sectin title and button */}
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className={styles.sliderOptions}>
                            <SectionTitle 
                                title="Rifles" 
                            />
                            <Button 
                                text="See all"
                            />
                        </div>
                    </div>
                </div>
            </div>
            {/* Rifle Slider  */}
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className={styles.RifleSliderWrapper}>
                            <Slider {...settings}>
                                {gunSliderData && gunSliderData.map((singleSlide,index) => (
                                    <SingleRifle
                                        title={singleSlide.title} 
                                        category={singleSlide.category}
                                        price={singleSlide.price}
                                        tag={singleSlide.tag}
                                        image={singleSlide.image}
                                        icon={singleSlide.icon}
                                        key={singleSlide.id}
                                    />
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    );
};

export default RifleSlider;